module.exports = __webpack_public_path__ + "fonts/nanumbarungothiclight-webfont.a1718d62.woff2";